import React, { createContext, useContext, useEffect, useState } from "react" 
import { Outlet, useParams, useNavigate } from "react-router-dom"
import _, { update } from "lodash"
import { Pencil, ChevronRight, ChevronDown, Plus, Save, X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, Dropdown, FieldGroup, FormLabel, InputField, Textarea, UnitTitleBlock } from "lib/components"
import { ELEMENTS, RULES_ACTIONS, sortArrayOfObjects } from "lib/utils"
import { RuleBuilder, RulesList, RulesFilterArea } from "./index"

const RulesEngineContext = createContext<any>({})
export const useRulesEngineCtx = () => useContext(RulesEngineContext)


const operators = [
  { label: "Must Equal", value: "eq" },
  { label: "Must Not Equal", value: "neq" },
  { label: "Must Contain", value: "contains" },
  { label: "Must Not Contain", value: "notcontains" },
  { label: "Must Exist", value: "exists" },
  { label: "Must Not Exist", value: "notexists" },
]


export default function RulesEnginePage({ className = "" }: { className?: string }){

  const [ engineState, setEngineState ] = useState<any>({
    selectedSection: null,
    selectedSubdomain: null,
    matchingRules: [],
    selectedRpid: null,
    selectedRule: null,
    newRuleTarget: { target: "", action: "" },
    subdomains: [],
    rpids: []
  })

  const updateEngineState = (path:string, data:any) => {
    setEngineState( (prev:any) => {
      const newState = _.set(_.cloneDeep(prev), path, data)
      return newState
    })
  }

  const { data:_Rules } = queryTools.resource.parseQueryForApi("rule.findAll", { location: engineState.selectedSection?.refstr }, { enabled: !!engineState.selectedSection?.refstr })
  const { data:_Rule } = queryTools.resource.parseQueryForApi("rule.findById", { _id: engineState.selectedRule?._id }, { enabled: !!engineState.selectedRule?._id })

  const saveFn = queryTools.resource.save(["rule.all"])
  
  const saveRule = (data:any) => saveFn.mutate({ resource: "Rule", data } )

  const updateRules = (changedRule:any) => {
    const updatedRules = engineState.matchingRules.map( (rule:any) => {
      if( rule._id === changedRule._id ) {
        return { ...rule, ...changedRule }
      }
      return rule
    })
    saveRule(updatedRules)
  }

  const getRulesEligibleFields = () => {
    if( !ELEMENTS ) return []
    const elements:any[] = ELEMENTS
    const elemConfig:any = elements.find( (elem:any) => elem.refstr === engineState.selectedSection.refstr ).config
    const fields = elemConfig.structure.filter( (item:any) => item.includeInRules === true).map( (item:any) => ({ label: item.label, value: item.refstr }) )
    const alsoInclude = elemConfig.alsoIncludeInRules || []
    return sortArrayOfObjects([...fields, ...alsoInclude], "label")
  }

  const handleRuleFormChange = (e:any) => {
    if( e.target.name.startsWith("config:") ){
      updateEngineState("selectedRule.config", { ...engineState.selectedRule.config, [e.target.name.replace("config:", "")]: e.target.value })
    } else {
      updateEngineState(`selectedRule.${e.target.name}`, e.target.value)
    }
  }


  return (
    <RulesEngineContext.Provider value={{ engineState, updateEngineState }}>
      <div className={cn("w-full pt-6", className)}>
        <UnitTitleBlock className="left-[10px] w-[calc(100%+10px)]" title="Rules Engine">
          <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" />
        </UnitTitleBlock>

        <div className="w-full flex items-stretch gap-4">
          
          <div className="w-2/12 flex flex-col items-stretch border border-solid border-slate-700">
            <RulesList />
          </div>

          { engineState.selectedSection !== null && (
            <div className={cn("flex flex-col w-4/12 border border-solid border-slate-700")}>
              <RulesFilterArea /> 
            </div>
          )}

          { engineState.selectedRule !== null && (
            <div className="w-6/12 flex flex-col items-stretch border border-solid border-slate-700">
              <RuleBuilder updateRules={updateRules} />
            </div>
          )}

        </div>
      </div>
    </RulesEngineContext.Provider>
  )
}